module.exports = __webpack_public_path__ + "static/Cel2ES-52b7e8c07c052fadd2e26ce699d6bb77.mp4";